import React from 'react';
import classes from "./LargeLoader.module.css";

const LargeLoader = () => {
    return (
        <div className={classes.loading}>
            <div className={classes.container}>
                <div className={classes.spinner}></div>
            </div>
        </div>
    )
}

export default LargeLoader